<template>
  <v-app>
    <v-app-bar
      app
      color="#34417C"
      dark
      class="headerContainer"
      v-if="isOn()"
    >
      <div  class="d-flex align-center justify-space-between header">
        <div>
          <v-img
            alt="Vuetify Logo"
            contain
            :src="require('./assets/img/logo.png')"
            @click="goHome"
            width="126"
          />
        </div>
        <div class="right-menu">
          <div class="avatar" v-if="profile.name !== undefined">
            <span>{{profile.name}} </span>
          </div>
          <v-btn color="transparent" elevation="0" @click.prevent="logout" class="logout">

            <v-img
              max-width="32"
              :src="require('./assets/img/icons/logout.png')"
              >
            </v-img>
          </v-btn>
        </div>

      </div>
    </v-app-bar>

    <v-main max-width="1440px" class="mainBackColor">
      <transition
        :name="transitionName"
        mode="out-in"
      >
        <router-view :key="$route.fullPath"></router-view>
      </transition>
    </v-main>
    <diary-date-validator />
    <reload-required />
  </v-app>
</template>

<script>
import { AUTH_LOGOUT } from '@/store/actions/auth'
import DiaryDateValidator from '@/components/Elements/DiaryDateValidator'
import ReloadRequired from '@/components/ReloadRequired'
const DEFAULT_TRANSITION = 'fade'
export default {
  name: 'app',

  components: {
    DiaryDateValidator,
    ReloadRequired
  },
  data () {
    return {
      transitionName: DEFAULT_TRANSITION,
      // profile: String,
      authenticated: Boolean
    }
  },
  created () {
    // this.profile = this.$store.getters.getProfile
    // console.log(this.$store.getters, 'getters')
    this.$router.beforeEach((to, from, next) => {
      let transitionName = to.meta.transitionName || from.meta.transitionName

      if (transitionName === 'slide') {
        const toDepth = to.path.split('/').length
        const fromDepth = from.path.split('/').length
        transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
      }

      this.transitionName = transitionName || DEFAULT_TRANSITION

      next()
    })
  },
  methods: {
    goHome: function (classroom) {
      this.$router.push({ name: 'classroomList' }).catch(() => {})
    },
    isOn: function () {
      return this.$store.getters.isAuthenticated
    },
    logout: function () {
      this.$store.dispatch(AUTH_LOGOUT).then(() => {
        this.$router.push('/')
      })
        .catch(error => {
          console.log({error})
        })
    }
  },
  computed: {
    profile () {
      return this.$store.getters.getProfile || {}
    }
  }
}
</script>
<style lang="scss">
  @import "./assets/scss/global.scss";
</style>




// WEBPACK FOOTER //
// src/App.vue